export const downloadJSONAsCSV = (jsonData) => {
    if(jsonData?.length < 1) {
        return;
    }

    // Convert JSON data to CSV
    let csvData = jsonToCsv(jsonData); // Add .items.data

    // Create a CSV file and allow the user to download it
    let blob = new Blob([csvData], { type: 'text/csv' });
    let url = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = url;
    a.download = 'data.csv';
    document.body.appendChild(a);
    a.click();
};

const jsonToCsv = (jsonData) => {
    let csv = '';
    // Get the headers
    let headers = Object.keys(jsonData[0]);
    csv += headers.join(',') + '\n';
    // Add the data
    jsonData.forEach(function (row) {
        let data = headers.map(header => JSON.stringify(row[header])).join(','); // Add JSON.stringify statement
        csv += data + '\n';
    });
    return csv;
};

export const csvToJson = (text, quoteChar = '"', delimiter = ',') => {
    let rows = text.split("\n");
    let headers = rows[0].split(",");

    const regex = new RegExp(`\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`, 'gs');
  
    const match = line => [...line.matchAll(regex)]
      .map(m => m[2]) 
      .slice(0, -1); 
  
    let lines = text.split('\n');
    const heads = headers ?? match(lines.shift());
    lines = lines.slice(1);
    
    return lines.map(line => {
      return match(line).reduce((acc, cur, i) => {
        // replace blank matches with `null`
        const val = cur.length <= 0 ? null : Number(cur) || cur;
        const key = heads[i] ?? `{i}`;
        return { ...acc, [key]: val };
      }, {});
    });
};

export const buildCsv=(headers,rows)=>{
  const csvLines = [];
  csvLines.push(headers.join(','));
  rows.forEach(row=>{
    const values=headers.map(h=>`"${(row[h]??'').toString().replace(/"/g,'""')}"`);
    csvLines.push(values.join(','));
  });
  return csvLines.join('\n');
}